import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import { Icon } from "@/components/icons/Icon";
import { usePhase } from "@/store/usePhase";
import { type FC } from "react";

interface ButtonClosePhaseProps {
  title: string;
  description: string;
  buttonLabel: string;
  onClick: (phaseId: number) => void;
}

const ButtonClosePhase: FC<ButtonClosePhaseProps> = ({
  title,
  description,
  buttonLabel,
  onClick,
}) => {
  const currentPhase = usePhase((store) => store.currentPhase!);
  const handleOnClick = () => {
    onClick(currentPhase);
  };

  return (
    <div className="w-full rounded-xs border border-ib-yellow-warning-dark bg-ib-yellow-warning-light px-4 py-3 text-sm shadow-sm">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-6 w-6 items-center justify-center">
            <Icon
              name="warningTriangle"
              className="size-4 text-ib-yellow-warning-darkest"
            />
          </div>
          <div className="text-ib-black-light text-base">
            <p className="font-ib-bold">{title}</p>
            <p className="mt-1">{description}</p>
          </div>
        </div>
        <div className="w-full md:w-auto flex ">
          <PrimaryButton
            onClick={handleOnClick}
            label={buttonLabel}
            colour={"red"}
            icon="checkUnderline"
          />
        </div>
      </div>
    </div>
  );
};

export default ButtonClosePhase;
